import { CapManageControllerContext } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/CapManageEntityFlow.tsx';
import { useContext } from 'react';

export const useDocuments = () => {
	const { selectedEntityName, selectedEntityId } = useContext(CapManageControllerContext);

	return {
		selectedEntityId,
		selectedEntityName,
	};
};
